import React from 'react';
import { Line } from 'react-chartjs-2';

const data = {
  labels: ['6/1/21 0:00',
    '6/1/21 1:00',
    '6/1/21 2:00',
    '6/1/21 3:00',
    '6/1/21 4:00',
    '6/1/21 5:00',
    '6/1/21 6:00',
    '6/1/21 7:00',
    '6/1/21 8:00',
    '6/1/21 9:00',
    '6/1/21 10:00',
    '6/1/21 11:00',
    '6/1/21 12:00',
    '6/1/21 13:00',
    '6/1/21 14:00',
    '6/1/21 15:00',
    '6/1/21 16:00',
    '6/1/21 17:00',
    '6/1/21 18:00',
    '6/1/21 19:00',
    '6/1/21 20:00',
    '6/1/21 21:00',
    '6/1/21 22:00',
    '6/1/21 23:00',
    '6/2/21 0:00',
    '6/2/21 1:00',
    '6/2/21 2:00',
    '6/2/21 3:00',
    '6/2/21 4:00',
    '6/2/21 5:00',
    '6/2/21 6:00',
    '6/2/21 7:00',
    '6/2/21 8:00',
    '6/2/21 9:00',
    '6/2/21 10:00',
    '6/2/21 11:00',
    '6/2/21 12:00',
    '6/2/21 13:00',
    '6/2/21 14:00',
    '6/2/21 15:00',
    '6/2/21 16:00',
    '6/2/21 17:00',
    '6/2/21 18:00',
    '6/2/21 19:00',
    '6/2/21 20:00',
    '6/2/21 21:00',
    '6/2/21 22:00',
    '6/2/21 23:00',
    '6/3/21 0:00',
    '6/3/21 1:00',
    '6/3/21 2:00',
    '6/3/21 3:00',
    '6/3/21 4:00',
    '6/3/21 5:00',
    '6/3/21 6:00',
    '6/3/21 7:00',
    '6/3/21 8:00',
    '6/3/21 9:00',
    '6/3/21 10:00',
    '6/3/21 11:00',
    '6/3/21 12:00',
    '6/3/21 13:00',
    '6/3/21 14:00',
    '6/3/21 15:00',
    '6/3/21 16:00',
    '6/3/21 17:00',
    '6/3/21 18:00',
    '6/3/21 19:00',
    '6/3/21 20:00',
    '6/3/21 21:00',
    '6/3/21 22:00',
    '6/3/21 23:00',
    '6/4/21 0:00',
    '6/4/21 1:00',
    '6/4/21 2:00',
    '6/4/21 3:00',
    '6/4/21 4:00',
    '6/4/21 5:00',
    '6/4/21 6:00',
    '6/4/21 7:00',
    '6/4/21 8:00',
    '6/4/21 9:00',
    '6/4/21 10:00',
    '6/4/21 11:00',
    '6/4/21 12:00',
    '6/4/21 13:00',
    '6/4/21 14:00',
    '6/4/21 15:00',
    '6/4/21 16:00',
    '6/4/21 17:00',
    '6/4/21 18:00',
    '6/4/21 19:00',
    '6/4/21 20:00',
    '6/4/21 21:00',
    '6/4/21 22:00',
    '6/4/21 23:00',
    '6/5/21 0:00',
    '6/5/21 1:00',
    '6/5/21 2:00',
    '6/5/21 3:00',
    '6/5/21 4:00',
    '6/5/21 5:00',
    '6/5/21 6:00',
    '6/5/21 7:00',
    '6/5/21 8:00',
    '6/5/21 9:00',
    '6/5/21 10:00',
    '6/5/21 11:00',
    '6/5/21 12:00',
    '6/5/21 13:00',
    '6/5/21 14:00',
    '6/5/21 15:00',
    '6/5/21 16:00',
    '6/5/21 17:00',
    '6/5/21 18:00',
    '6/5/21 19:00',
    '6/5/21 20:00',
    '6/5/21 21:00',
    '6/5/21 22:00',
    '6/5/21 23:00',
    '6/6/21 0:00',
    '6/6/21 1:00',
    '6/6/21 2:00',
    '6/6/21 3:00',
    '6/6/21 4:00',
    '6/6/21 5:00',
    '6/6/21 6:00',
    '6/6/21 7:00',
    '6/6/21 8:00',
    '6/6/21 9:00',
    '6/6/21 10:00',
    '6/6/21 11:00',
    '6/6/21 12:00',
    '6/6/21 13:00',
    '6/6/21 14:00',
    '6/6/21 15:00',
    '6/6/21 16:00',
    '6/6/21 17:00',
    '6/6/21 18:00',
    '6/6/21 19:00',
    '6/6/21 20:00',
    '6/6/21 21:00',
    '6/6/21 22:00',
    '6/6/21 23:00',
    '6/7/21 0:00',
    '6/7/21 1:00',
    '6/7/21 2:00',
    '6/7/21 3:00',
    '6/7/21 4:00',
    '6/7/21 5:00',
    '6/7/21 6:00',
    '6/7/21 7:00',
    '6/7/21 8:00',
    '6/7/21 9:00',
    '6/7/21 10:00',
    '6/7/21 11:00',
    '6/7/21 12:00',
    '6/7/21 13:00',
    '6/7/21 14:00',
    '6/7/21 15:00',
    '6/7/21 16:00',
    '6/7/21 17:00',
    '6/7/21 18:00',
    '6/7/21 19:00',
    '6/7/21 20:00',
    '6/7/21 21:00',
    '6/7/21 22:00',
    '6/7/21 23:00',
    '6/8/21 0:00',
    '6/8/21 1:00',
    '6/8/21 2:00',
    '6/8/21 3:00',
    '6/8/21 4:00',
    '6/8/21 5:00',
    '6/8/21 6:00',
    '6/8/21 7:00',
    '6/8/21 8:00',
    '6/8/21 9:00',
    '6/8/21 10:00',
    '6/8/21 11:00',
    '6/8/21 12:00',
    '6/8/21 13:00',
    '6/8/21 14:00',
    '6/8/21 15:00',
    '6/8/21 16:00',
    '6/8/21 17:00',
    '6/8/21 18:00',
    '6/8/21 19:00',
    '6/8/21 20:00',
    '6/8/21 21:00',
    '6/8/21 22:00',
    '6/8/21 23:00',
    '6/9/21 0:00',
    '6/9/21 1:00',
    '6/9/21 2:00',
    '6/9/21 3:00',
    '6/9/21 4:00',
    '6/9/21 5:00',
    '6/9/21 6:00',
    '6/9/21 7:00',
    '6/9/21 8:00',
    '6/9/21 9:00',
    '6/9/21 10:00',
    '6/9/21 11:00',
    '6/9/21 12:00',
    '6/9/21 13:00',
    '6/9/21 14:00',
    '6/9/21 15:00',
    '6/9/21 16:00',
    '6/9/21 17:00',
    '6/9/21 18:00',
    '6/9/21 19:00',
    '6/9/21 20:00',
    '6/9/21 21:00',
    '6/9/21 22:00',
    '6/9/21 23:00',
    '6/10/21 0:00',
    '6/10/21 1:00',
    '6/10/21 2:00',
    '6/10/21 3:00',
    '6/10/21 4:00',
    '6/10/21 5:00',
    '6/10/21 6:00',
    '6/10/21 7:00',
    '6/10/21 8:00',
    '6/10/21 9:00',
    '6/10/21 10:00',
    '6/10/21 11:00',
    '6/10/21 12:00',
    '6/10/21 13:00',
    '6/10/21 14:00',
    '6/10/21 15:00',
    '6/10/21 16:00',
    '6/10/21 17:00',
    '6/10/21 18:00',
    '6/10/21 19:00',
    '6/10/21 20:00',
    '6/10/21 21:00',
    '6/10/21 22:00',
    '6/10/21 23:00',
    '6/11/21 0:00',
    '6/11/21 1:00',
    '6/11/21 2:00',
    '6/11/21 3:00',
    '6/11/21 4:00',
    '6/11/21 5:00',
    '6/11/21 6:00',
    '6/11/21 7:00',
    '6/11/21 8:00',
    '6/11/21 9:00',
    '6/11/21 10:00',
    '6/11/21 11:00',
    '6/11/21 12:00',
    '6/11/21 13:00',
    '6/11/21 14:00',
    '6/11/21 15:00',
    '6/11/21 16:00',
    '6/11/21 17:00',
    '6/11/21 18:00',
    '6/11/21 19:00',
    '6/11/21 20:00',
    '6/11/21 21:00',
    '6/11/21 22:00',
    '6/11/21 23:00',
    '6/12/21 0:00',
    '6/12/21 1:00',
    '6/12/21 2:00',
    '6/12/21 3:00',
    '6/12/21 4:00',
    '6/12/21 5:00',
    '6/12/21 6:00',
    '6/12/21 7:00',
    '6/12/21 8:00',
    '6/12/21 9:00',
    '6/12/21 10:00',
    '6/12/21 11:00',
    '6/12/21 12:00',
    '6/12/21 13:00',
    '6/12/21 14:00',
    '6/12/21 15:00',
    '6/12/21 16:00',
    '6/12/21 17:00',
    '6/12/21 18:00',
    '6/12/21 19:00',
    '6/12/21 20:00',
    '6/12/21 21:00',
    '6/12/21 22:00',
    '6/12/21 23:00',
    '6/13/21 0:00',
    '6/13/21 1:00',
    '6/13/21 2:00',
    '6/13/21 3:00',
    '6/13/21 4:00',
    '6/13/21 5:00',
    '6/13/21 6:00',
    '6/13/21 7:00',
    '6/13/21 8:00',
    '6/13/21 9:00',
    '6/13/21 10:00',
    '6/13/21 11:00',
    '6/13/21 12:00',
    '6/13/21 13:00',
    '6/13/21 14:00',
    '6/13/21 15:00',
    '6/13/21 16:00',
    '6/13/21 17:00',
    '6/13/21 18:00',
    '6/13/21 19:00',
    '6/13/21 20:00',
    '6/13/21 21:00',
    '6/13/21 22:00',
    '6/13/21 23:00',
    '6/14/21 0:00',
    '6/14/21 1:00',
    '6/14/21 2:00',
    '6/14/21 3:00',
    '6/14/21 4:00',
    '6/14/21 5:00',
    '6/14/21 6:00',
    '6/14/21 7:00',
    '6/14/21 8:00',
    '6/14/21 9:00',
    '6/14/21 10:00',
    '6/14/21 11:00',
    '6/14/21 12:00',
    '6/14/21 13:00',
    '6/14/21 14:00',
    '6/14/21 15:00',
    '6/14/21 16:00',
    '6/14/21 17:00',
    '6/14/21 18:00',
    '6/14/21 19:00',
    '6/14/21 20:00',
    '6/14/21 21:00',
    '6/14/21 22:00',
    '6/14/21 23:00',
    '6/15/21 0:00',
    '6/15/21 1:00',
    '6/15/21 2:00',
    '6/15/21 3:00',
    '6/15/21 4:00',
    '6/15/21 5:00',
    '6/15/21 6:00',
    '6/15/21 7:00',
    '6/15/21 8:00',
    '6/15/21 9:00',
    '6/15/21 10:00',
    '6/15/21 11:00',
    '6/15/21 12:00',
    '6/15/21 13:00',
    '6/15/21 14:00',
    '6/15/21 15:00',
    '6/15/21 16:00',
    '6/15/21 17:00',
    '6/15/21 18:00',
    '6/15/21 19:00',
    '6/15/21 20:00',
    '6/15/21 21:00',
    '6/15/21 22:00',
    '6/15/21 23:00',
    '6/16/21 0:00',
    '6/16/21 1:00',
    '6/16/21 2:00',
    '6/16/21 3:00',
    '6/16/21 4:00',
    '6/16/21 5:00',
    '6/16/21 6:00',
    '6/16/21 7:00',
    '6/16/21 8:00',
    '6/16/21 9:00',
    '6/16/21 10:00',
    '6/16/21 11:00',
    '6/16/21 12:00',
    '6/16/21 13:00',
    '6/16/21 14:00',
    '6/16/21 15:00',
    '6/16/21 16:00',
    '6/16/21 17:00',
    '6/16/21 18:00',
    '6/16/21 19:00',
    '6/16/21 20:00',
    '6/16/21 21:00',
    '6/16/21 22:00',
    '6/16/21 23:00',
    '6/17/21 0:00',
    '6/17/21 1:00',
    '6/17/21 2:00',
    '6/17/21 3:00',
    '6/17/21 4:00',
    '6/17/21 5:00',
    '6/17/21 6:00',
    '6/17/21 7:00',
    '6/17/21 8:00',
    '6/17/21 9:00',
    '6/17/21 10:00',
    '6/17/21 11:00',
    '6/17/21 12:00',
    '6/17/21 13:00',
    '6/17/21 14:00',
    '6/17/21 15:00',
    '6/17/21 16:00',
    '6/17/21 17:00',
    '6/17/21 18:00',
    '6/17/21 19:00',
    '6/17/21 20:00',
    '6/17/21 21:00',
    '6/17/21 22:00',
    '6/17/21 23:00',
    '6/18/21 0:00',
    '6/18/21 1:00',
    '6/18/21 2:00',
    '6/18/21 3:00',
    '6/18/21 4:00',
    '6/18/21 5:00',
    '6/18/21 6:00',
    '6/18/21 7:00',
    '6/18/21 8:00',
    '6/18/21 9:00',
    '6/18/21 10:00',
    '6/18/21 11:00',
    '6/18/21 12:00',
    '6/18/21 13:00',
    '6/18/21 14:00',
    '6/18/21 15:00',
    '6/18/21 16:00',
    '6/18/21 17:00',
    '6/18/21 18:00',
    '6/18/21 19:00',
    '6/18/21 20:00',
    '6/18/21 21:00',
    '6/18/21 22:00',
    '6/18/21 23:00',
    '6/19/21 0:00',
    '6/19/21 1:00',
    '6/19/21 2:00',
    '6/19/21 3:00',
    '6/19/21 4:00',
    '6/19/21 5:00',
    '6/19/21 6:00',
    '6/19/21 7:00',
    '6/19/21 8:00',
    '6/19/21 9:00',
    '6/19/21 10:00',
    '6/19/21 11:00',
    '6/19/21 12:00',
    '6/19/21 13:00',
    '6/19/21 14:00',
    '6/19/21 15:00',
    '6/19/21 16:00',
    '6/19/21 17:00',
    '6/19/21 18:00',
    '6/19/21 19:00',
    '6/19/21 20:00',
    '6/19/21 21:00',
    '6/19/21 22:00',
    '6/19/21 23:00',
    '6/20/21 0:00',
    '6/20/21 1:00',
    '6/20/21 2:00',
    '6/20/21 3:00',
    '6/20/21 4:00',
    '6/20/21 5:00',
    '6/20/21 6:00',
    '6/20/21 7:00',
    '6/20/21 8:00',
    '6/20/21 9:00',
    '6/20/21 10:00',
    '6/20/21 11:00',
    '6/20/21 12:00',
    '6/20/21 13:00',
    '6/20/21 14:00',
    '6/20/21 15:00',
    '6/20/21 16:00',
    '6/20/21 17:00',
    '6/20/21 18:00',
    '6/20/21 19:00',
    '6/20/21 20:00',
    '6/20/21 21:00',
    '6/20/21 22:00',
    '6/20/21 23:00',
    '6/21/21 0:00',
    '6/21/21 1:00',
    '6/21/21 2:00',
    '6/21/21 3:00',
    '6/21/21 4:00',
    '6/21/21 5:00',
    '6/21/21 6:00',
    '6/21/21 7:00',
    '6/21/21 8:00',
    '6/21/21 9:00',
    '6/21/21 10:00',
    '6/21/21 11:00',
    '6/21/21 12:00',
    '6/21/21 13:00',
    '6/21/21 14:00',
    '6/21/21 15:00',
    '6/21/21 16:00',
    '6/21/21 17:00',
    '6/21/21 18:00',
    '6/21/21 19:00',
    '6/21/21 20:00',
    '6/21/21 21:00',
    '6/21/21 22:00',
    '6/21/21 23:00',
    '6/22/21 0:00',
    '6/22/21 1:00',
    '6/22/21 2:00',
    '6/22/21 3:00',
    '6/22/21 4:00',
    '6/22/21 5:00',
    '6/22/21 6:00',
    '6/22/21 7:00',
    '6/22/21 8:00',
    '6/22/21 9:00',
    '6/22/21 10:00',
    '6/22/21 11:00',
    '6/22/21 12:00',
    '6/22/21 13:00',
    '6/22/21 14:00',
    '6/22/21 15:00',
    '6/22/21 16:00',
    '6/22/21 17:00',
    '6/22/21 18:00',
    '6/22/21 19:00',
    '6/22/21 20:00',
    '6/22/21 21:00',
    '6/22/21 22:00',
    '6/22/21 23:00',
    '6/23/21 0:00',
    '6/23/21 1:00',
    '6/23/21 2:00',
    '6/23/21 3:00',
    '6/23/21 4:00',
    '6/23/21 5:00',
    '6/23/21 6:00',
    '6/23/21 7:00',
    '6/23/21 8:00',
    '6/23/21 9:00',
    '6/23/21 10:00',
    '6/23/21 11:00',
    '6/23/21 12:00',
    '6/23/21 13:00',
    '6/23/21 14:00',
    '6/23/21 15:00',
    '6/23/21 16:00',
    '6/23/21 17:00',
    '6/23/21 18:00',
    '6/23/21 19:00',
    '6/23/21 20:00',
    '6/23/21 21:00',
    '6/23/21 22:00',
    '6/23/21 23:00',
    '6/24/21 0:00',
    '6/24/21 1:00',
    '6/24/21 2:00',
    '6/24/21 3:00',
    '6/24/21 4:00',
    '6/24/21 5:00',
    '6/24/21 6:00',
    '6/24/21 7:00',
    '6/24/21 8:00',
    '6/24/21 9:00',
    '6/24/21 10:00',
    '6/24/21 11:00',
    '6/24/21 12:00',
    '6/24/21 13:00',
    '6/24/21 14:00',
    '6/24/21 15:00',
    '6/24/21 16:00',
    '6/24/21 17:00',
    '6/24/21 18:00',
    '6/24/21 19:00',
    '6/24/21 20:00',
    '6/24/21 21:00',
    '6/24/21 22:00',
    '6/24/21 23:00',
    '6/25/21 0:00',
    '6/25/21 1:00',
    '6/25/21 2:00',
    '6/25/21 3:00',
    '6/25/21 4:00',
    '6/25/21 5:00',
    '6/25/21 6:00',
    '6/25/21 7:00',
    '6/25/21 8:00',
    '6/25/21 9:00',
    '6/25/21 10:00',
    '6/25/21 11:00',
    '6/25/21 12:00',
    '6/25/21 13:00',
    '6/25/21 14:00',
    '6/25/21 15:00',
    '6/25/21 16:00',
    '6/25/21 17:00',
    '6/25/21 18:00',
    '6/25/21 19:00',
    '6/25/21 20:00',
    '6/25/21 21:00',
    '6/25/21 22:00',
    '6/25/21 23:00',
    '6/26/21 0:00',
    '6/26/21 1:00',
    '6/26/21 2:00',
    '6/26/21 3:00',
    '6/26/21 4:00',
    '6/26/21 5:00',
    '6/26/21 6:00',
    '6/26/21 7:00',
    '6/26/21 8:00',
    '6/26/21 9:00',
    '6/26/21 10:00',
    '6/26/21 11:00',
    '6/26/21 12:00',
    '6/26/21 13:00',
    '6/26/21 14:00',
    '6/26/21 15:00',
    '6/26/21 16:00',
    '6/26/21 17:00',
    '6/26/21 18:00',
    '6/26/21 19:00',
    '6/26/21 20:00',
    '6/26/21 21:00',
    '6/26/21 22:00',
    '6/26/21 23:00',
    '6/27/21 0:00',
    '6/27/21 1:00',
    '6/27/21 2:00',
    '6/27/21 3:00',
    '6/27/21 4:00',
    '6/27/21 5:00',
    '6/27/21 6:00',
    '6/27/21 7:00',
    '6/27/21 8:00',
    '6/27/21 9:00',
    '6/27/21 10:00',
    '6/27/21 11:00',
    '6/27/21 12:00',
    '6/27/21 13:00',
    '6/27/21 14:00',
    '6/27/21 15:00',
    '6/27/21 16:00',
    '6/27/21 17:00',
    '6/27/21 18:00',
    '6/27/21 19:00',
    '6/27/21 20:00',
    '6/27/21 21:00',
    '6/27/21 22:00',
    '6/27/21 23:00',
    '6/28/21 0:00',
    '6/28/21 1:00',
    '6/28/21 2:00',
    '6/28/21 3:00',
    '6/28/21 4:00',
    '6/28/21 5:00',
    '6/28/21 6:00',
    '6/28/21 7:00',
    '6/28/21 8:00',
    '6/28/21 9:00',
    '6/28/21 10:00',
    '6/28/21 11:00',
    '6/28/21 12:00',
    '6/28/21 13:00',
    '6/28/21 14:00',
    '6/28/21 15:00',
    '6/28/21 16:00',
    '6/28/21 17:00',
    '6/28/21 18:00',
    '6/28/21 19:00',
    '6/28/21 20:00',
    '6/28/21 21:00',
    '6/28/21 22:00',
    '6/28/21 23:00',
    '6/29/21 0:00',
    '6/29/21 1:00',
    '6/29/21 2:00',
    '6/29/21 3:00',
    '6/29/21 4:00',
    '6/29/21 5:00',
    '6/29/21 6:00',
    '6/29/21 7:00',
    '6/29/21 8:00',
    '6/29/21 9:00',
    '6/29/21 10:00',
    '6/29/21 11:00',
    '6/29/21 12:00',
    '6/29/21 13:00',
    '6/29/21 14:00',
    '6/29/21 15:00',
    '6/29/21 16:00',
    '6/29/21 17:00',
    '6/29/21 18:00',
    '6/29/21 19:00',
    '6/29/21 20:00',
    '6/29/21 21:00',
    '6/29/21 22:00',
    '6/29/21 23:00',
    '6/30/21 0:00',
    '6/30/21 1:00',
    '6/30/21 2:00',
    '6/30/21 3:00',
    '6/30/21 4:00',
    '6/30/21 5:00',
    '6/30/21 6:00',
    '6/30/21 7:00',
    '6/30/21 8:00',
    '6/30/21 9:00',
    '6/30/21 10:00',
    '6/30/21 11:00',
    '6/30/21 12:00',
    '6/30/21 13:00',
    '6/30/21 14:00',
    '6/30/21 15:00',
    '6/30/21 16:00',
    '6/30/21 17:00',
    '6/30/21 18:00',
    '6/30/21 19:00',
    '6/30/21 20:00',
    '6/30/21 21:00',
    '6/30/21 22:00',
    '6/30/21 23:00',
  ],
  datasets: [
    {
      label: false,
      fill: false,
      lineTension: 0.1,
      backgroundColor: 'rgba(75,192,192,0.4)',
      borderColor: 'rgba(75,192,192,1)',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: 'rgba(75,192,192,1)',
      pointBackgroundColor: '#fff',
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: 'rgba(75,192,192,1)',
      pointHoverBorderColor: 'rgba(220,220,220,1)',
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      data: [
        43.619,
        34.094,
        44.385,
        36.935,
        45.662,
        50.016,
        29.677,
        42.940,
        42.447,
        39.554,
        40.792,
        43.189,
        51.773,
        36.386,
        41.782,
        34.509,
        35.793,
        33.633,
        36.336,
        42.465,
        40.888,
        46.838,
        41.690,
        43.070,
        41.259,
        48.707,
        39.920,
        41.250,
        43.105,
        42.028,
        42.894,
        40.183,
        44.529,
        42.506,
        47.854,
        33.278,
        42.804,
        45.724,
        30.402,
        43.872,
        33.690,
        46.126,
        36.156,
        47.671,
        38.771,
        41.536,
        34.665,
        37.726,
        40.100,
        29.129,
        42.246,
        29.211,
        40.489,
        43.139,
        41.540,
        40.699,
        41.812,
        42.101,
        43.751,
        42.693,
        39.278,
        42.317,
        37.316,
        41.656,
        40.934,
        44.492,
        38.657,
        44.911,
        42.098,
        31.489,
        30.135,
        41.420,
        42.608,
        39.720,
        35.739,
        40.337,
        43.086,
        40.218,
        33.557,
        44.256,
        35.579,
        26.070,
        41.056,
        33.248,
        39.340,
        29.976,
        33.988,
        38.040,
        36.560,
        22.332,
        41.700,
        37.031,
        32.940,
        40.323,
        38.045,
        43.716,
        34.585,
        49.628,
        43.553,
        35.161,
        39.475,
        37.672,
        47.712,
        41.126,
        43.126,
        32.312,
        39.850,
        39.421,
        37.343,
        37.458,
        45.744,
        38.752,
        39.054,
        42.941,
        35.751,
        40.171,
        43.120,
        34.842,
        44.931,
        41.030,
        38.305,
        39.294,
        30.793,
        35.943,
        49.854,
        41.200,
        42.112,
        35.162,
        37.041,
        40.063,
        38.107,
        44.365,
        37.751,
        38.767,
        35.398,
        33.765,
        47.153,
        36.041,
        39.946,
        34.190,
        42.565,
        33.575,
        35.031,
        35.517,
        49.367,
        37.412,
        34.916,
        39.149,
        48.194,
        47.563,
        42.064,
        39.401,
        44.134,
        39.032,
        35.881,
        40.969,
        40.528,
        38.485,
        36.579,
        28.834,
        39.078,
        45.960,
        47.003,
        42.760,
        38.920,
        25.272,
        35.934,
        45.323,
        45.664,
        43.773,
        35.073,
        37.142,
        40.281,
        39.682,
        36.985,
        39.139,
        37.694,
        39.204,
        43.373,
        30.378,
        38.990,
        40.336,
        42.393,
        38.293,
        37.286,
        46.371,
        39.009,
        34.435,
        45.890,
        35.159,
        42.226,
        37.164,
        29.537,
        39.135,
        40.204,
        36.628,
        40.324,
        39.322,
        44.424,
        33.079,
        36.564,
        39.507,
        41.122,
        38.134,
        39.143,
        36.266,
        29.929,
        42.606,
        39.653,
        37.542,
        40.296,
        43.874,
        40.528,
        36.544,
        36.284,
        38.918,
        35.983,
        42.917,
        46.637,
        41.610,
        45.747,
        42.647,
        45.624,
        36.673,
        35.303,
        37.893,
        38.322,
        43.596,
        45.241,
        48.087,
        39.299,
        45.514,
        37.381,
        36.886,
        47.602,
        31.866,
        42.858,
        38.387,
        36.305,
        35.611,
        29.502,
        38.112,
        37.086,
        41.576,
        42.431,
        43.417,
        40.166,
        36.245,
        34.381,
        36.167,
        40.856,
        46.610,
        44.480,
        40.061,
        43.551,
        43.266,
        37.564,
        39.106,
        39.193,
        47.055,
        34.632,
        37.546,
        50.263,
        37.283,
        38.617,
        50.048,
        35.051,
        37.117,
        41.996,
        37.971,
        41.915,
        42.283,
        41.048,
        43.948,
        44.809,
        52.942,
        33.149,
        31.576,
        34.857,
        38.461,
        42.781,
        39.811,
        40.329,
        36.537,
        35.201,
        40.122,
        35.075,
        37.957,
        36.341,
        31.118,
        40.418,
        39.782,
        43.600,
        39.586,
        37.748,
        44.127,
        30.129,
        38.007,
        33.413,
        44.050,
        49.006,
        43.790,
        40.507,
        47.715,
        41.818,
        53.517,
        30.728,
        32.659,
        42.524,
        43.905,
        49.863,
        36.794,
        43.701,
        47.773,
        34.038,
        45.691,
        35.877,
        42.945,
        41.901,
        40.233,
        31.981,
        44.207,
        41.776,
        35.758,
        42.408,
        42.868,
        44.126,
        45.529,
        34.870,
        48.038,
        28.571,
        43.983,
        41.655,
        42.148,
        42.120,
        53.137,
        40.892,
        38.956,
        33.940,
        42.116,
        40.680,
        38.819,
        42.081,
        50.061,
        43.565,
        41.278,
        34.995,
        36.523,
        33.112,
        36.914,
        37.276,
        41.042,
        47.796,
        29.935,
        42.540,
        41.386,
        38.716,
        39.070,
        41.533,
        36.237,
        49.767,
        35.627,
        31.789,
        39.014,
        43.795,
        33.636,
        38.205,
        41.287,
        43.647,
        41.387,
        39.355,
        47.405,
        38.836,
        39.129,
        38.705,
        29.972,
        37.370,
        41.927,
        36.171,
        39.968,
        47.600,
        49.289,
        41.095,
        45.269,
        36.553,
        32.136,
        32.928,
        37.117,
        35.411,
        35.389,
        33.582,
        37.211,
        41.368,
        41.867,
        39.145,
        41.777,
        37.733,
        42.507,
        44.341,
        34.991,
        35.143,
        39.014,
        37.763,
        35.861,
        40.615,
        39.327,
        46.112,
        41.639,
        38.829,
        43.574,
        35.967,
        38.081,
        39.707,
        38.081,
        39.895,
        50.164,
        40.531,
        42.450,
        32.555,
        34.669,
        37.647,
        30.477,
        39.855,
        41.640,
        32.102,
        53.213,
        34.073,
        36.143,
        30.167,
        40.976,
        33.383,
        39.176,
        34.621,
        31.699,
        41.983,
        39.022,
        34.235,
        36.886,
        40.121,
        34.741,
        43.739,
        40.874,
        31.711,
        33.194,
        42.138,
        39.247,
        43.291,
        33.229,
        41.225,
        45.569,
        35.477,
        36.851,
        41.636,
        38.764,
        36.867,
        45.379,
        39.591,
        44.801,
        38.085,
        46.428,
        46.663,
        36.001,
        39.488,
        41.696,
        51.570,
        38.257,
        36.854,
        42.631,
        42.398,
        36.286,
        35.167,
        50.538,
        48.175,
        45.910,
        37.390,
        41.828,
        45.278,
        38.597,
        34.993,
        48.749,
        37.518,
        41.924,
        36.838,
        46.576,
        37.512,
        44.922,
        30.447,
        50.028,
        40.560,
        36.111,
        42.135,
        35.975,
        32.457,
        30.390,
        38.048,
        45.834,
        48.384,
        34.664,
        33.776,
        32.762,
        40.349,
        33.361,
        41.096,
        44.966,
        39.651,
        46.873,
        43.147,
        40.257,
        41.893,
        37.960,
        36.858,
        38.688,
        39.896,
        36.951,
        49.089,
        31.044,
        33.988,
        29.864,
        46.639,
        37.453,
        36.855,
        39.730,
        43.329,
        42.594,
        37.479,
        45.249,
        36.689,
        46.263,
        45.506,
        28.876,
        36.327,
        42.973,
        35.866,
        42.370,
        42.045,
        37.837,
        35.098,
        46.715,
        35.504,
        35.531,
        40.640,
        29.466,
        43.312,
        43.797,
        43.261,
        42.069,
        47.396,
        41.971,
        31.185,
        41.158,
        41.155,
        41.951,
        39.534,
        41.911,
        43.073,
        42.756,
        47.302,
        46.116,
        41.995,
        40.772,
        45.254,
        35.868,
        29.845,
        42.587,
        42.739,
        41.519,
        41.065,
        38.829,
        36.186,
        29.884,
        44.926,
        42.637,
        44.480,
        38.385,
        28.039,
        40.958,
        39.750,
        38.529,
        30.930,
        45.825,
        39.932,
        44.930,
        44.594,
        27.682,
        37.461,
        39.061,
        44.297,
        42.622,
        38.409,
        33.473,
        39.514,
        39.188,
        43.422,
        47.921,
        44.318,
        34.248,
        48.928,
        46.007,
        30.141,
        39.927,
        46.345,
        50.757,
        39.243,
        36.218,
        47.283,
        41.797,
        46.027,
        43.830,
        32.299,
        45.139,
        45.199,
        42.495,
        39.929,
        41.255,
        41.760,
        37.027,
        38.940,
        33.010,
        43.243,
        37.232,
        42.415,
        41.254,
        45.745,
        34.011,
        37.045,
        40.839,
        43.944,
        37.755,
        41.097,
        40.502,
        52.131,
        43.593,
        36.539,
        43.731,
        42.318,
        40.915,
        43.050,
        42.562,
        47.074,
        43.793,
        39.879,
        52.571,
        48.571,
        42.128,
        42.494,
        43.840,
        38.935,
        43.995,
        36.377,
        41.963,
        44.637,
        43.538,
        36.283,
        36.737,
        40.013,
        43.841,
        39.255,
        39.196,
        44.472,
        33.539,
        25.112,
        42.975,
        38.330,
        38.868,
        41.009,
        37.608,
        38.166,
        41.843,
        31.859,
        40.789,
        41.231,
        32.511,
        31.989,
        42.299,
        42.230,
        31.465,
        39.690,
        32.937,
        33.609,
        43.597,
        49.479,
        35.188,
        49.518,
        37.304,
        37.194,
        41.896,
        50.171,
        32.238,
        40.138,
        43.135,
        42.571,
        36.557,
        34.219,
        44.711,
        47.331,
        53.929,
        39.828,
        35.129,
        39.883,
        38.752,
        45.800,
        40.828,
        35.463,
        35.622,
        38.605,
        45.698,
        34.394,
        39.478,
        32.584,
        45.088,
        32.273,
        31.242,
        40.739,
        35.875,
        40.854,
        33.883,
        33.453,
        48.336,
        36.741,
        38.653
      ]
    }
  ]
};

export default class SampleLineChart extends React.Component {
  render() {
    return (
      <div>
        <Line
          ref="chart"
          data={data}
          options={{
            title: {
              display: false
            },
            legend: {
              display: false
            }
          }}
        />
      </div>
    );
  }
}
